import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme, _params, getRef) => ({
  simpleGrid: {
    alignItems: "center",
  },
}));
